import * as Yup from "yup";

export const validateEmailAddress = async ({
  emailAddress,
  config: { fieldName, required = false, t },
  errorsCollector = {},
}) => {
  try {
    const fieldSchema = Yup.string()
      .required(t("errors.formRequiredField", { fieldName: t("common.email") }))
      .email(t("errors.invalidFieldValue", { fieldName: t("common.email") }));
    await fieldSchema.validate(emailAddress, {
      abortEarly: true,
      recursive: true,
    });
  } catch (error) {
    console.log(">>>> ERROR1111111 ", error);
    if (error instanceof Yup.ValidationError) {
      errorsCollector[fieldName] = error.message;
      return;
    }
    throw error;
  } finally {
    return errorsCollector;
  }
};

export const validateSyncEmailAddress = ({
  emailAddress,
  config: { fieldName, required = false, t },
  errorsCollector = {},
}) => {
  try {
    const fieldSchema = Yup.string()
      .required(t("errors.formRequiredField", { fieldName: t("common.email") }))
      .email(t("errors.invalidFieldValue", { fieldName: t("common.email") }));
    fieldSchema.validateSync(emailAddress, {
      abortEarly: true,
      recursive: true,
    });
  } catch (error) {
    console.log(">>>> error ######", error);
    if (error instanceof Yup.ValidationError) {
      errorsCollector[fieldName] = error.message;
    } else {
      throw error;
    }
  }
  return errorsCollector;
};
